module.exports = __webpack_public_path__ + "img/war-of-talent-min.ab82e447.jpg";